"use client";

import { createContext, useContext } from 'use-context-selector';

/**
 * @deprecated Avoid using this context as this module is deprecated.
 */
export const InitialPresenceContext = createContext(false);

/**
 * @deprecated Avoid using this context as this module is deprecated.
 */
export const useInitialPresence = () => useContext(InitialPresenceContext);
